import { useQuery } from '@tanstack/react-query'
import {
  fetchParticipantSupervisor,
  ParticipantSupervisorResponse,
} from '../index'

const useParticipantSupervisor = (consumerId: string | undefined) =>
  useQuery<{ data: ParticipantSupervisorResponse }, Error>({
    queryKey: ['participantSupervisor', consumerId],
    queryFn: () => fetchParticipantSupervisor(consumerId as string),
    enabled: !!consumerId,
    staleTime: 0,
  })

export { useParticipantSupervisor }
